import { render, staticRenderFns } from "./productDemonstration.vue?vue&type=template&id=6418d7fb&scoped=true&"
import script from "./productDemonstration.vue?vue&type=script&lang=js&"
export * from "./productDemonstration.vue?vue&type=script&lang=js&"
import style0 from "./productDemonstration.vue?vue&type=style&index=0&id=6418d7fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418d7fb",
  null
  
)

export default component.exports